module.exports = __webpack_public_path__ + "static/media/logo_prefix.696c3a9b.svg";